export const SHOPPING_CART_EVENTS = {
  ADD_PRODUCT: "ice_shopping-cart_add-product",
  FAMILY_CONTEXT_UPDATED: "ice_shopping-cart_is-family-context-updated",
  ADD_PRODUCT_NOTIFICATION: "ice_shopping-cart_add-product-notification",
  OPEN_SERVICE_SELECTOR_VIEW: "ice_shopping-cart-open-selector-view",
  SET_OPEN_STATE: "ice_shopping-cart-set-open-state",
  OPEN_STATE_CHANGED: "ice_shopping-cart-open-state-changed",
  GO_TO_CHECKOUT: "ice_shopping-cart_go-to-checkout",
  CLOSE_BY_SHOP_MORE_BUTTON: "ice_shopping-cart_close-by-shop-more-button",
};

export const SHOPPING_CART_STORAGE_KEYS = {
  IS_FAMILY_CONTEXT: "ice-voice_is-family-context",
};

export const Mbb_SHOPPING_CART_EVENTS = {
  ADD_PRODUCT: "ice_mbbshopping-cart_add-product",
  FULL: "ice_mbbshopping-cart_full",
  NOT_FULL: "ice_mbbshopping-cart_not-full",
  GO_TO_CHECKOUT: "ice_mbbshopping-cart_go-to-checkout",
};
